import React from 'react';

import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BackButton } from '@/presentation/modules/procedures/components';
import Spinner from '@/presentation/components/Spinner';
import Processing from '@/presentation/components/Processing';
import InfoComponent from '../info/components/InfoComponent';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import Step from '../../UpdatePhoto/Register/components/Step';
import Block from '@/presentation/components/Block';
import { WhiteContainer } from '../../ChangeCareerCampusModality/info/components';
import { ListUL } from '../info/components/LateralPDF';
import WarningComponent from '../../RectificationOfNotes/register/helpers/WarningComponent';
import ReusableButton from '@/presentation/reusables/Button';
import CheckBox from '../../../scholarships/bse/components/CheckBox';
import ModalWrapper from '../info/components/ModalWrapper';
import TextHelper from '@/core/helpers/TextHelper';

interface RegisterProps {
  onBack: () => void;
  procedureSelectedInfo: any;
  content: {
    viewContent: boolean;
    setViewContent: (value: boolean) => void;
  };
  check: {
    checkDocument: boolean;
    setCheckDocument: (value: boolean) => void;
  };
  handleRegister: () => void;
  isLoadingRegister: boolean;
  dataEmail: any;
  student: any;
}

const GraduatedCertificateRegisterView: React.FC<RegisterProps> = (props) => {
  const { onBack, procedureSelectedInfo, content, handleRegister } = props;
  const { isLoadingRegister, dataEmail, student, check } = props;
  const { viewContent, setViewContent } = content;
  const { checkDocument, setCheckDocument } = check;

  const renderLoadingOrError = () => {
    if (!procedureSelectedInfo || !dataEmail) {
      return <Spinner />;
    }
    return null;
  };
  return (
    <ContainerProcedure>
      <SubContainer style={{ marginBottom: 24 }}>
        <BackButton onClick={onBack} />
      </SubContainer>
      <Processing isOpen={isLoadingRegister} />
      {renderLoadingOrError()}
      <SubContainer>
        {procedureSelectedInfo && dataEmail && (
          <>
            <ToggleHeader
              name={procedureSelectedInfo.name}
              amount={procedureSelectedInfo.amount}
              duration={procedureSelectedInfo.duration}
              date={procedureSelectedInfo.endDate}
              childContent={
                <InfoComponent
                  inRegister
                  steps={procedureSelectedInfo.stepsToFollow}
                  setShowModel={() => {}}
                />
              }
            />
            <TextTitle title="Progreso" />
            <Block customized padding="28px 0px 45px 8px">
              <Step
                name={procedureSelectedInfo.steps[0].name}
                order={procedureSelectedInfo.steps[0].order}
              >
                <WhiteContainer>
                  <b>Verifica los datos que aparecerán en tu constancia:</b>
                  <ListUL>
                    <li>
                      Nombres y apellidos:{' '}
                      {`${TextHelper.capitalize(
                        student.profile.firstName
                      )} ${TextHelper.capitalize(student.profile.lastName)}`}
                    </li>
                    <li>
                      Carrera:{' '}
                      {TextHelper.capitalize(student.academic.progDesc)}
                    </li>
                  </ListUL>
                  <b style={{ marginTop: 16 }}>
                    Verifica los datos que necesitamos para gestionar tu
                    constancia:
                  </b>
                  <ListUL>
                    <li>
                      Documento de identidad:{' '}
                      {TextHelper.capitalize(student.profile.dni)}
                    </li>
                    <li>Correo: {dataEmail?.email?.email}</li>
                    <li>Celular: {dataEmail?.phone?.phoneNumber}</li>
                  </ListUL>
                  <WarningComponent>
                    <p>
                      Si necesitas corregir tildes o datos, haz lo siguiente:
                    </p>
                    <ListUL>
                      <li>
                        <p>
                          Nombres, apellidos y documento de identidad: registra
                          una{' '}
                          <a
                            style={{
                              color: '#5B36F2',
                              textDecorationLine: 'underline'
                            }}
                            href="https://portal.utp.edu.pe/tramites/ticketera/registro?v=TA0001"
                            target="_blank"
                            rel="noreferrer"
                          >
                            solicitud de modificación de datos personales.
                          </a>
                        </p>
                      </li>
                      <li>
                        <p>
                          Correo y celular: edítalos desde tu{' '}
                          <a
                            style={{
                              color: '#5B36F2',
                              textDecorationLine: 'underline'
                            }}
                            href="https://portal.utp.edu.pe/perfil/informacion-personal"
                            target="_blank"
                            rel="noreferrer"
                          >
                            perfil.
                          </a>
                        </p>
                      </li>
                    </ListUL>
                  </WarningComponent>
                  <br />
                  <p>
                    Antes de continuar, lee el reglamento de datos personales.
                    Necesitamos tu aceptación para continuar.
                  </p>
                  <ReusableButton
                    text={'Leer reglamento'}
                    style={{ padding: '12px 24px', marginTop: '12px' }}
                    onClick={() => setViewContent(true)}
                    outlined
                  />
                  <br />
                  <CheckBox
                    handleOnChange={() => setCheckDocument(!checkDocument)}
                    value={
                      'Acepto haber leído el reglamento de protección de datos personales y estar de acuerdo.'
                    }
                    checked={checkDocument}
                    style={{
                      fontWeight: 400
                    }}
                    firstLabel="Acepto haber leído el reglamento de protección de datos personales y estar de acuerdo."
                  />
                  <br />
                  <ReusableButton
                    disabled={!checkDocument}
                    text={'Siguiente'}
                    style={{ padding: '12px 24px', marginTop: '12px' }}
                    onClick={handleRegister}
                  />
                </WhiteContainer>
              </Step>
              <Step
                name={procedureSelectedInfo.steps[1].name}
                order={procedureSelectedInfo.steps[1].order}
                disabled
              />
              <Step
                name={procedureSelectedInfo.steps[2].name}
                order={procedureSelectedInfo.steps[2].order}
                disabled
                isLast
              />
            </Block>
          </>
        )}
      </SubContainer>
      {viewContent && (
        <ModalWrapper
          isOpen
          onClose={() => {
            setViewContent(false);
            setCheckDocument(true);
          }}
          onClickButton={() => {
            setViewContent(false);
            setCheckDocument(true);
          }}
          pdf
          name="Reglamento de protección de datos personales"
        />
      )}
    </ContainerProcedure>
  );
};

export default GraduatedCertificateRegisterView;
